// quizThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../components/config";
// export const createQuiz = createAsyncThunk(
//   "quiz/createQuiz",
//   async ({ formData, userId }, { rejectWithValue }) => {
//     try {
//       const body = {
//         title: formData.title,
//         start_date: formData.start,
//         total_questions: formData.totalQuestions,
//         duration_per_question: formData.questionDuration,
//         allotments: formData.allotments,
//         registration_start_date: formData.registrationStart,
//         registration_end_date: formData.registrationEnd,
//         marks_per_question: Number(formData.correct),
//         negative_marks_wrong: Number(formData.wrong),
//         negative_marks_skipped: Number(formData.skipped),
//         registration_fee: parseFloat(formData.registrationCost).toFixed(2),
//         prizes: formData.winnerPrizes.reduce((acc, val, idx) => {
//           acc[(idx + 1).toString()] = parseFloat(val || 0).toFixed(2);
//           return acc;
//         }, {}),
//         registration_type: formData.registrationFeeMode,
//         about_quiz: formData.about,
//         quiz_terms: formData.terms,
//         created_by: userId,
//       };

//       const res = await axios.post("/admin/create-quiz", body);
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );
export const createQuiz = createAsyncThunk(
  "quiz/createQuiz",
  async (body, { rejectWithValue }) => {
    try {
      // const body = {
      //   title: formData.title,
      //   start_date: formData.start,
      //   total_questions: formData.totalQuestions,
      //   duration_per_question: formData.questionDuration,
      //   allotments: formData.allotments,
      //   registration_start_date: formData.registrationStart,
      //   registration_end_date: formData.registrationEnd,
      //   marks_per_question: Number(formData.correct),
      //   negative_marks_wrong: Number(formData.wrong),
      //   negative_marks_skipped: Number(formData.skipped),
      //   registration_fee: parseFloat(formData.registrationCost).toFixed(2),
      //   prizes: formData.winnerPrizes.reduce((acc, val, idx) => {
      //     acc[(idx + 1).toString()] = parseFloat(val || 0).toFixed(2);
      //     return acc;
      //   }, {}),
      //   registration_type: formData.registrationFeeMode,
      //   about_quiz: formData.about,
      //   quiz_terms: formData.terms,
      //   created_by: userId,
      // };
      const res = await axios.post(
        `${API_BASE_URL}/quiz/admin/create-quiz`,
        body
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getUsersList = createAsyncThunk(
  "quiz/getUsersList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/quiz/admin/users`);
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const imageUpload = createAsyncThunk(
  "quiz/imageUpload",
  async ({ image, id }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quiz/admin/quizzes`);
      const formData = new FormData();
      formData.append("image", image);
      const res = await axios.put(
        `${API_BASE_URL}/quiz/admin/quiz/${id}`,
        formData
      ); // ✅ awai
      console.log(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizzes = createAsyncThunk(
  "quiz/getQuizzes",
  async (_, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quiz/admin/quizzes`);
      const res = await axios.get(`${API_BASE_URL}/quiz/admin/quizzes`); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const updateQuiz = createAsyncThunk(
  "quiz/updateQuiz",
  async (body, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quiz/admin/quizzes`);
      const res = await axios.put(
        `${API_BASE_URL}/quiz/admin/update-quiz`,
        body
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteQuiz = createAsyncThunk(
  "quiz/deleteQuiz",
  async ({ quiz_id, updated_by }, { rejectWithValue }) => {
    try {
      // const body = { quiz_id, updated_by };
      // const res = axios.get(`${API_BASE_URL}/quiz/admin/quizzes`);
      const res = await axios.delete(`${API_BASE_URL}/quiz/admin/delete-quiz`, {
        data: { quiz_id, updated_by }, // 👈 body must be inside data
      }); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const publishOrUnpublish = createAsyncThunk(
  "quiz/publishOrUnpublish",
  async ({ id }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quiz/admin/quizzes`);
      const res = await axios.post(
        `${API_BASE_URL}/quiz/admin/status-change?quiz_id=${id}`
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getRegisteredQuizUsersList = createAsyncThunk(
  "quiz/getRegisteredQuizUsersList",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/quiz/admin/participants/${id}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 4 SEPT
export const getQuizParticipants = createAsyncThunk(
  "quiz/getQuizParticipants",
  async ({ quiz_id, limit = 10, offset }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/quiz/admin/live-quiz-participants?quiz_id=${quiz_id}&limit=${limit}&offset=${offset}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizParticipantsOld = createAsyncThunk(
  "quiz/getQuizParticipantsOld",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/quiz/admin/quiz-participants-details/${quiz_id}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
